import { embedMAAP } from '@web_software/maap';

import '@web_software/maap/dist/maap.embed.css';

function embedSolarIrradiation() {
  const allScripts = document.querySelectorAll('script');
  const allScriptSources = [...allScripts].map((s) => s.src);
  const thisScriptSource = allScriptSources.find((s) =>
    s.includes('dist/scripts_europa.min.js')
  );
  const url = thisScriptSource.slice(
    0,
    thisScriptSource.indexOf('dist') + 'dist'.length
  );

  embedMAAP({
    container: document.getElementById('mt-content'),
    stylesheetUrl: 'placeholder',
    integrationUrl: `${url}/strahlungskarten_europa.min.js`,
  });
}

embedSolarIrradiation();
